/* eslint no-shadow: off */

import * as mutationTypes from '@/store/mutation-types';
import User from '@/model/User';
import { DEPARTMENT } from '@/enum/UserDepartments';
import api from '@/api';
import activeOfficeService from '@/service/ActiveOfficeService';
import authInstance from '@/auth';

const state = {
  user: new User(),
  activeOffice: activeOfficeService.getActiveOffice(),
  userOffices: [],
};

const getters = {
  user: state => state.user,
  activeOffice: state => state.activeOffice,
  allUserOffices: state => state.userOffices,
  isAuthenticated: state => state.user.id != null,
  isPreparer: state => state.user && state.user.departmentId === DEPARTMENT.TAX_PREPARER,
  isAccountant: state => state.user && state.user.departmentId === DEPARTMENT.ACCOUNTANT,
  isManager: state => state.user
    && (
      state.user.departmentId === DEPARTMENT.MANAGER
      || state.user.departmentId === DEPARTMENT.DISTRICT_MANAGER
      || state.user.departmentId === DEPARTMENT.ADMIN
      || state.user.departmentId === DEPARTMENT.SUPER_ADMIN
    ),
  isDistrictManager: state => state.user
    && (
      state.user.departmentId === DEPARTMENT.DISTRICT_MANAGER
      || state.user.departmentId === DEPARTMENT.ADMIN
      || state.user.departmentId === DEPARTMENT.SUPER_ADMIN
    ),
  isAdmin: state => state.user
    && (state.user.departmentId === DEPARTMENT.ADMIN
      || state.user.departmentId === DEPARTMENT.SUPER_ADMIN),
};

const actions = {
  async initCurrentUser({ dispatch }) {
    return dispatch('loadCurrentUser');
  },
  getUserOffices({ commit, state }) {
    return api.lookup.offices().then((response) => {
      if (response.data && response.data.length && state.activeOffice == null) {
        commit(mutationTypes.USER_ACTIVE_OFFICE, response.data[0].id);
      }
      commit(mutationTypes.USER_OFFICES, response.data);
    });
  },
  async authenticate({ dispatch }, credentials) {
    try {
      authInstance.reset();
      const response = await api.user.authenticate(credentials);
      if (response.data.user && response.data.accessToken && response.data.refreshToken) {
        authInstance.saveTokens(response.data.user.id, response.data.accessToken, response.data.refreshToken);
        await dispatch('loadCurrentUser');
      }
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  async authenticateSupervisor(_, credentials) {
    try {
      const response = await api.user.authenticate(credentials);

      return response.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  updateActiveOffice({ commit }, officeId) {
    commit(mutationTypes.USER_ACTIVE_OFFICE, officeId);
  },
  async loadCurrentUser({ commit, dispatch }) {
    const response = await api.user.current();
    const currentUser = response.data;
    commit(mutationTypes.USER_UPDATE_USER, currentUser);
    if (currentUser.physicalOfficeLocation > 0) {
      commit(mutationTypes.USER_ACTIVE_OFFICE, currentUser.physicalOfficeLocation);
    }
    dispatch('getUserOffices');

    return currentUser;
  },
  signOut({ commit, dispatch }) {
    commit(mutationTypes.USER_UPDATE_USER, new User());
    authInstance.reset();
    activeOfficeService.reset();
    dispatch('loadCurrentUser');
  },
};

const mutations = {
  [mutationTypes.USER_UPDATE_USER](state, user) {
    state.user = user;
  },

  [mutationTypes.USER_OFFICES](state, offices) {
    state.userOffices = offices;
  },

  [mutationTypes.USER_ACTIVE_OFFICE](state, officeId) {
    console.info('setting active office', officeId);
    state.activeOffice = officeId;
    activeOfficeService.setActiveOffice(officeId);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
